import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as CreditorDetailsActions from '../actions/creditor-details.actions';
import { CreditorDetailsHttpService } from '../services/creditor-details-http.service';

@Injectable()
export class CreditorDetailsEffects {

  constructor(
    private readonly actions: Actions,
    private readonly detailsService: CreditorDetailsHttpService
  ) { }

  load = createEffect(() => this.actions.pipe(
    ofType(CreditorDetailsActions.loadDetails),
    mergeMap(action => {
      return this.detailsService.getCreditorDetails(action.widgetConfigId, action.creditorUri).pipe(
        map(details => CreditorDetailsActions.loadDetailsComplete({
          details: details,
          widgetConfigId: action.widgetConfigId,
          widgetId: action.widgetId
        }))
      );
    })
  ));

}
